import Cookies from 'js-cookie'

export class Loading {
  constructor() {
    this.isLoaded = false
    this.cookieName = 'uni-kyoto-iken-at'
    this.body = document.body

    this.init()
  }

  init() {
    const cookie = Cookies.get(this.cookieName)

    if (!cookie) {
      this.body.classList.add('is-opening', 'is-start')
      this.setupEvents()
      this.setCookie()
    } else {
      this.body.classList.add('is-start')
      this.setupEvents()
    }
  }

  setupEvents() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.onDOMReady())
    } else {
      this.onDOMReady()
    }

    if (document.readyState === 'complete') {
      this.onLoad()
    } else {
      window.addEventListener('load', () => this.onLoad())
    }
  }

  onDOMReady() {
    this.body.classList.add('is-ready')
  }

  onLoad() {
    this.body.classList.add('is-loaded')
    this.isLoaded = true
  }

  setCookie() {
    const date = new Date()
    date.setTime(date.getTime() + (10 * 60 * 1000))
    Cookies.set(this.cookieName, '1', {
      expires: date,
      sameSite: 'lax'
    })
  }
}